/* eslint-disable react/jsx-no-target-blank */
import {AsideMenuItem} from '../../_metronic/layout/components/aside/AsideMenuItem'
import {useAuth} from '../modules/auth'
import {FEATURE_OPTIONS, verifyFeature} from '../modules/feature-toggle/verifyFeature'

export function AsideClientMenu() {
  const {userVerifyRoles, isAdmin} = useAuth()

  return (
    <>
      {userVerifyRoles([
        'Benchmarking Editor',
        'Benchmarking Reader',
        'Labor Editor',
        'Labor Reader',
      ]) && (
        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Collections</span>
          </div>
        </div>
      )}

      {userVerifyRoles(['Benchmarking Editor', 'Benchmarking Reader']) && (
        <AsideMenuItem
          to='/c/collections?periodTypes=6aba8918-711c-40e0-ab9d-bcbdddd5e29f&collectionTypes=&procesSteps='
          icon='/media/icons/duotune/general/gen051.svg'
          title='Benchmarking'
          fontIcon='bi-layers'
        />
      )}

      {userVerifyRoles(['Labor Editor', 'Labor Reader']) && (
        <AsideMenuItem
          to='/c/collections?periodTypes=6aba8918-711c-40e0-ab9d-bcbdddd5e29d&collectionTypes=&procesSteps='
          icon='/media/icons/duotune/general/gen051.svg'
          title='Labor'
          fontIcon='bi-layers'
        />
      )}

      {userVerifyRoles(['Benchmarking Editor', 'Benchmarking Reader']) && (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-uppercase fs-8 ls-1'>
                Benchmarking Reports
              </span>
            </div>
          </div>
          <AsideMenuItem
            to='/c/reporting?periodTypes=6aba8918-711c-40e0-ab9d-bcbdddd5e29f'
            icon='/media/icons/duotune/general/gen051.svg'
            title='Reports'
            fontIcon='bi-layers'
          />
          <AsideMenuItem
            to='/c/reporting?periodTypes=7aba8918-711c-40e0-ab9d-bcbdddd5e29f'
            icon='/media/icons/duotune/general/gen051.svg'
            title='Graphs'
            fontIcon='bi-layers'
          />
          <AsideMenuItem
            to='/c/reportBuilder'
            icon='/media/icons/duotune/general/gen051.svg'
            title='Report Builder'
            fontIcon='bi-layers'
          />
        </>
      )}

      {userVerifyRoles(['Labor Editor', 'Labor Reader']) && (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-uppercase fs-8 ls-1'>
                Labor Reports
              </span>
            </div>
          </div>
          <AsideMenuItem
            to='/c/reporting?periodTypes=6aba8918-711c-40e0-ab9d-bcbdddd5e29d'
            icon='/media/icons/duotune/general/gen051.svg'
            title='Reports'
            fontIcon='bi-layers'
          />
        </>
      )}

      {isAdmin ? (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-uppercase fs-8 ls-1'>
                Benchmarking Admin
              </span>
            </div>
          </div>

          {verifyFeature(FEATURE_OPTIONS.CALCULATION) && (
            <AsideMenuItem
              to='/c/calculationManager'
              icon='/media/icons/duotune/general/gen051.svg'
              title='Calculation Manager'
              fontIcon='bi-layers'
            />
          )}
          {verifyFeature(FEATURE_OPTIONS.GROUP) && (
            <AsideMenuItem
              to='/c/groupManager'
              icon='/media/icons/duotune/general/gen051.svg'
              title='Group Manager'
              fontIcon='bi-layers'
            />
          )}

          <AsideMenuItem
            to='/c/dataforms/forms'
            icon='/media/icons/duotune/general/gen051.svg'
            title='Data Forms'
            fontIcon='bi-layers'
          />

          <AsideMenuItem
            to='/c/periodEditor'
            icon='/media/icons/duotune/general/gen051.svg'
            title='Period Editor'
            fontIcon='bi-layers'
          />

          {verifyFeature(FEATURE_OPTIONS.ADMIN_ACTIONS) && (
            <AsideMenuItem
              to='/c/adminActions'
              icon='/media/icons/duotune/general/gen051.svg'
              title='Actions'
              fontIcon='bi-layers'
            />
          )}
        </>
      ) : null}
    </>
  )
}
